// @flow

import { delegate } from '../utils/tools';

let categoryNav: ?HTMLElement = null;
let categoryNavContainer: ?HTMLElement = null;

function handleDropdownClick() {
	if (!categoryNavContainer || !categoryNav) {
		return;
	}

	let className = 'blog-category-nav-active';
	categoryNavContainer.classList.toggle(className);

	let isActive = categoryNavContainer.classList.contains(className);

	if (isActive) {
		categoryNav.setAttribute('aria-hidden', 'false');
	} else {
		categoryNav.setAttribute('aria-hidden', 'true');
	}
}

function bindEvents() {
	if (!categoryNav) {
		return;
	}

	delegate(
		categoryNav,
		'[data-js="blog-category-nav-toggle"]',
		'click',
		handleDropdownClick
	);
}

export default function init() {
	categoryNav = document.querySelector('[data-js=blog-category-nav]');

	if (!categoryNav) {
		return;
	}

	categoryNavContainer = document.querySelector(
		'[data-js=blog-category-nav-mobile]'
	);

	bindEvents();
}
